import { render, staticRenderFns } from "./goBackWindow.vue?vue&type=template&id=ac261510&scoped=true&"
import script from "./goBackWindow.vue?vue&type=script&lang=js&"
export * from "./goBackWindow.vue?vue&type=script&lang=js&"
import style0 from "./goBackWindow.vue?vue&type=style&index=0&id=ac261510&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac261510",
  null
  
)

export default component.exports